import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "util--screen-reader" }
const _hoisted_2 = { class: "content-grid" }

import {useI18n} from "vue3-i18n"
import {useMemberStore} from "@/stores/memberStore";
import MemberOrganizationForm from "@/views/member/MemberOrganizationForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Membership',
  setup(__props) {

const {t} = useI18n()
const memberStore = useMemberStore()
const member = memberStore.getMember;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)("routes.membership.name")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MemberOrganizationForm, {
        "organization-id": _unref(member).organizationId
      }, null, 8, ["organization-id"])
    ])
  ]))
}
}

})